import { Reducer } from 'redux/utils/Details'

import actionTypes from './clientServicePlanDetailsActionTypes'
import stateClass from './ClientServicePlanDetailsInitialState'

export default Reducer({ actionTypes, stateClass })